Apt.fn.extend('maps', {
	/**
	 * Pause positioning
	 */
	pausePosition() {
		this.$private.static = true;
	},

	/**
	 * Resume positioning
	 */
	resumePosition() {
		const scope = this;

		setTimeout(() => {
			scope.ready(() => {
				scope.$private.static = false;
			});
		}, 150);
	},

	/**
	 * Parse variables from position
	 *
	 * @returns {Object}
	 */
	parsePosition() {
		const center = LS.filters.get('center');

		if (center && center.length === 2) {
			const zoom = LS.filters.get('zoom');

			return {
				center: [
					Number(center[0]),
					Number(center[1])
				],
				zoom: zoom ?
					Number(zoom) : null
			};
		}

		return null;
	},

	/**
	 * Get parsed or map position
	 *
	 * @returns {Object}
	 */
	getPosition() {
		const scope = this;

		if (! scope.map) {
			return null;
		}

		if (! scope.$private.static) {
			const position = scope.parsePosition();

			if (position) {
				return position;
			}
		}

		return {
			center: scope.getCenter(true),
			zoom: scope.getZoom(true)
		};
	}
}, {
	/**
	 * Update position to current values
	 */
	updatePosition() {
		const scope = this;
		const pub = scope.$public;

		if (! scope.conf.position || scope.static) {
			return;
		}

		LS.filters.merge({
			center: pub.getCenter(true),
			zoom: pub.getZoom(true)
		});

		$.history.replace(
			LS.filters.build(LS.filters.root(), LS.filters.get())
		);
	}
});